class AccordionFooter extends HTMLElement {
  constructor() {
    super();
    this.mq = window.matchMedia('(max-width: 1439px)');
    this.accordionHandler = this.handleClick.bind(this);
    this.transitionHandler = this.handleTransition.bind(this);
    this.resizeHandler = this.handleResize.bind(this);
  }

  connectedCallback() {
    this.btn = this.querySelector('[toggle-accordion]');
    this.list = this.querySelector('.menu-block-list');
    this.icon = this.querySelector('[rotate-icon]');

    if (!this.btn || !this.list) return;

    this.mq.addEventListener('change', this.resizeHandler);
    this.init(this.mq.matches);
  }

  disconnectedCallback() {
    this.mq.removeEventListener('change', this.resizeHandler);
    if (this.btn) this.btn.removeEventListener('click', this.accordionHandler);
    if (this.list) this.list.removeEventListener('transitionend', this.transitionHandler);
  }

  handleResize(e) {
    this.init(e.matches);
  }

  init(isMobile) {
    if (isMobile) {
      this.list.style.overflow = 'hidden';
      this.list.style.height = '0px';
      this.list.classList.remove('is-open');
      if (this.icon) this.icon.classList.add('rotate-180');

      this.list.addEventListener('transitionend', this.transitionHandler);
      this.btn.addEventListener('click', this.accordionHandler);
    } else {
      this.list.classList.add('is-open');
      this.list.style.overflow = '';
      this.list.style.height = 'auto';
      if (this.icon) this.icon.classList.remove('rotate-180');

      this.list.removeEventListener('transitionend', this.transitionHandler);
      this.btn.removeEventListener('click', this.accordionHandler);
    }
  }

  handleClick(e) {
    e.preventDefault();
    const isOpening = !this.list.classList.contains('is-open');

    if (isOpening) {
      this.closeOthers();
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.list.classList.add('is-open');
    this.list.style.height = '0px';
    const fullHeight = this.list.scrollHeight;
    this.list.style.height = `${fullHeight}px`;
    if (this.icon) this.icon.classList.remove('rotate-180');
  }

  close() {
    const currentHeight = this.list.scrollHeight;
    this.list.style.height = `${currentHeight}px`;
    void this.list.offsetHeight;
    this.list.classList.remove('is-open');
    this.list.style.height = '0px';
    if (this.icon) this.icon.classList.add('rotate-180');
  }

  closeOthers() {
    document.querySelectorAll('accordion-footer').forEach((el) => {
      if (el !== this && el.close) {
        el.close();
      }
    });
  }

  handleTransition(e) {
    if (e.propertyName !== 'height') return;
    if (this.list.classList.contains('is-open')) {
      this.list.style.height = 'auto';
    }
  }
}

customElements.define('accordion-footer', AccordionFooter);